/**
 * Example JavaScript singleton module
 */

var Clock = (function($) {
  function initClock() {
    (function initBarcelonaClock() {
      const hourHand = document.getElementById("hour-hand");
      const minuteHand = document.getElementById("minute-hand");

      if (!hourHand || !minuteHand) return;

      const TIMEZONE = "Europe/Madrid";

      function getBarcelonaTime() {
        const parts = new Intl.DateTimeFormat("en-GB", {
          timeZone: TIMEZONE,
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false,
        }).formatToParts(new Date());

        const map = Object.fromEntries(parts.map((p) => [p.type, p.value]));

        return {
          h: parseInt(map.hour, 10),
          m: parseInt(map.minute, 10),
          s: parseInt(map.second, 10),
        };
      }

      function updateClock() {
        const { h, m, s } = getBarcelonaTime();

        // Horas: 360 / 12 = 30°
        const hourDeg = ((h % 12) + m / 60 + s / 3600) * 30;

        // Minutos: 360 / 60 = 6°
        const minuteDeg = (m + s / 60) * 6;

        // ROTACIÓN SVG NATIVA (no CSS)
        hourHand.setAttribute("transform", `rotate(${hourDeg} 12 12)`);
        minuteHand.setAttribute("transform", `rotate(${minuteDeg} 12 12)`);
      }

      updateClock();
      setInterval(updateClock, 1000); // suave y preciso
    })();
  }

  function init() {
    // return early if no corresponding module present
    if (!$("header").length) {
      return;
    }

    initClock();
  }

  return {
    init: init,
  };
})(jQuery);

jQuery(document).ready(Clock.init);
